(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["all-brands-directory"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('brand-directory')) {
    customElements.define('brand-directory', class extends HTMLElement {
      connectedCallback() {
        this.search = this.querySelector('[type="search"]');
        this.items = [...this.querySelectorAll('[data-brand]')];
        this.filters = [...this.querySelectorAll('[data-letter]')];
        this.empty = this.querySelector('.brand-directory__empty');
        this.activeLetter = 'all';

        const initials = new Set(this.items.map((item) => item.dataset.initial));
        this.filters.forEach((button) => {
          if (button.dataset.letter !== 'all' && !initials.has(button.dataset.letter)) button.disabled = true;
          button.addEventListener('click', () => this.selectLetter(button));
        });

        this.search?.addEventListener('input', () => this.update());
      }

      selectLetter(button) {
        this.activeLetter = button.dataset.letter;
        this.filters.forEach((filter) => {
          const active = filter === button;
          filter.classList.toggle('is-active', active);
          filter.setAttribute('aria-pressed', String(active));
        });
        this.update();
      }

      update() {
        const term = this.search?.value.trim().toLowerCase() || '';
        let visible = 0;

        this.items.forEach((item) => {
          const matchesSearch = !term || item.dataset.brand.includes(term);
          const matchesLetter = this.activeLetter === 'all' || item.dataset.initial === this.activeLetter;
          const show = matchesSearch && matchesLetter;
          item.hidden = !show;
          if (show) visible += 1;
        });

        if (this.empty) this.empty.hidden = visible > 0;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
